import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../lib/cn'

/**
 * Números do dashboard em grade de fio (1px entre cartões, sem sombra).
 * Cada número vem com o rótulo acima e a explicação em uma linha abaixo ("bruto menos ressarcimentos").
 * Só o número crítico ganha plum; os outros seguem preto. Número sem contexto não entra.
 */

export function KpiGrid({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="kpi-grid"
      className={cn(
        'border-hairline bg-hairline grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-px border',
        className,
      )}
      {...props}
    />
  )
}

export interface KpiProps extends HTMLAttributes<HTMLDivElement> {
  label: ReactNode
  value: ReactNode
  note?: ReactNode
  /** `critical` tinge o número em plum — reservado ao que representa risco (ex.: "sem assinatura"). */
  tone?: 'default' | 'critical'
  /** Número-herói: Lexend 38px, para o valor principal do período. */
  hero?: boolean
}

export function Kpi({ label, value, note, tone = 'default', hero, className, ...props }: KpiProps) {
  return (
    <div data-slot="kpi" className={cn('bg-surface px-5 py-[18px]', className)} {...props}>
      <div className="font-body text-eyebrow text-label leading-[1.4] font-light tracking-[.12em] uppercase">
        {label}
      </div>
      <div
        className={cn(
          'font-display mt-[10px] font-extralight whitespace-nowrap',
          hero ? 'text-hero' : 'text-[28px] leading-[1.1]',
          tone === 'critical' ? 'text-plum' : 'text-ink',
        )}
      >
        {value}
      </div>
      {note ? (
        <div className="font-body text-eyebrow text-secondary mt-[6px] leading-[1.5] font-light tracking-normal">
          {note}
        </div>
      ) : null}
    </div>
  )
}
